import { Badge } from "react-bootstrap"
import { useQuery } from "react-query"
import { getJobAssigneesReport } from "../../../services/jobs"
import SortableTable from "reactstrap-sortable-table";
import { useEffect, useState } from "react";
import { roleLabel } from "../../../constants/labels";
import { onQuerySuccess } from "../../../utils/queryResponse";
import { initColumns } from "../../../utils/helper";
import JobAssigneesReportFilter from "./jobAssigneesFilter";
import OverlayLoader from "../../../components/overlayLoader";
import { SkeletonRows } from "../../../components/skeleton";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Avatar from "../../../components/avatar";

const pageStyles = `
  .sbr .topperf{position:relative;overflow:hidden;border-radius:var(--r);padding:20px 24px;margin-bottom:18px;
    background:var(--brand-grad);box-shadow:var(--sh-brand);color:#fff;display:flex;align-items:center;gap:20px}
  .sbr .topperf::after{content:"";position:absolute;right:-60px;top:-80px;width:260px;height:260px;border-radius:50%;
    background:radial-gradient(circle,rgba(255,255,255,.16) 0%,rgba(255,255,255,0) 70%)}
  .sbr .topperf .tp-av{position:relative;z-index:1;width:64px;height:64px;border-radius:18px;flex-shrink:0;
    background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.28);
    display:flex;align-items:center;justify-content:center;font-size:20px;font-weight:800;letter-spacing:-.5px}
  .sbr .topperf .tp-mid{position:relative;z-index:1;min-width:0}
  .sbr .topperf .tp-tag{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:800;letter-spacing:.5px;
    text-transform:uppercase;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.26);
    border-radius:999px;padding:4px 11px;margin-bottom:8px}
  .sbr .topperf .tp-tag .ic{width:13px;height:13px}
  .sbr .topperf .tp-name{font-size:22px;font-weight:800;letter-spacing:-.6px;line-height:1}
  .sbr .topperf .tp-role{font-size:12.5px;font-weight:600;color:rgba(255,255,255,.82);margin-top:4px}
  .sbr .topperf .tp-stats{position:relative;z-index:1;margin-left:auto;display:flex;gap:24px;text-align:right;flex-shrink:0}
  .sbr .topperf .tp-stats .s .v{font-size:18px;font-weight:800;letter-spacing:-.5px;font-variant-numeric:tabular-nums}
  .sbr .topperf .tp-stats .s .k{font-size:11px;font-weight:600;color:rgba(255,255,255,.76);margin-top:3px}
  .sbr .rank-cap{display:flex;align-items:center;gap:10px;margin:4px 0 12px}
  .sbr .rank-cap .t{font-size:13.5px;font-weight:800;color:var(--ink);letter-spacing:-.2px}
  .sbr .rank-cap .h{font-size:11px;font-weight:600;color:var(--muted)}
  .sbr .rank-cap .line{flex:1;height:1px;background:var(--line)}
  .sbr .arow{display:flex;align-items:center;gap:16px;background:var(--card);border:1px solid var(--line);
    border-radius:var(--r-md);padding:14px 16px;margin-bottom:10px;box-shadow:var(--sh-2);position:relative;overflow:hidden;cursor:pointer;transition:transform .14s ease,box-shadow .14s ease}
  .sbr .arow:hover{transform:translateY(-1px);box-shadow:var(--sh-3)}
  .sbr .arow::before{content:"";position:absolute;left:0;top:0;bottom:0;width:3px;background:var(--brand-grad);opacity:0}
  .sbr .arow.lead::before{opacity:1}
  .sbr .arow .rk{width:22px;flex-shrink:0;text-align:center;font-size:14px;font-weight:800;color:var(--faint);font-variant-numeric:tabular-nums}
  .sbr .arow.lead .rk{color:var(--brand)}
  .sbr .arow .av{width:42px;height:42px;border-radius:13px;flex-shrink:0;display:flex;align-items:center;
    justify-content:center;font-size:13px;font-weight:800;background:var(--brand-50);border:1px solid var(--brand-100);color:var(--brand-ink)}
  .sbr .arow .who{min-width:160px;flex-shrink:0}
  .sbr .arow .who .nm{font-size:14px;font-weight:800;color:var(--ink);letter-spacing:-.2px}
  .sbr .arow .who .rl{font-size:12px;font-weight:600;color:var(--muted);margin-top:2px}
  .sbr .arow .stat{flex-shrink:0;text-align:right;min-width:70px}
  .sbr .arow .stat .v{font-size:14px;font-weight:800;color:var(--ink);letter-spacing:-.2px;font-variant-numeric:tabular-nums}
  .sbr .arow .stat .k{font-size:10px;font-weight:700;color:var(--faint);text-transform:uppercase;letter-spacing:.4px;margin-top:2px}
  .sbr .arow .wl{flex:1;min-width:100px;padding-left:6px}
  .sbr .arow .wl .wl-top{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:5px}
  .sbr .arow .wl .wl-lab{font-size:10px;font-weight:700;color:var(--faint);text-transform:uppercase;letter-spacing:.4px}
  .sbr .arow .wl .wl-pct{font-size:11.5px;font-weight:800;color:var(--muted);font-variant-numeric:tabular-nums}
  .sbr .arow.lead .wl .wl-pct{color:var(--brand-ink)}
  .sbr .barrow{display:flex;align-items:center;gap:11px;margin-bottom:8px}
  .sbr .barrow:last-child{margin-bottom:0}
  .sbr .barrow .bn{font-size:12.5px;font-weight:700;color:var(--text);width:84px;flex-shrink:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  .sbr .barrow .bv{font-size:12px;font-weight:800;color:var(--ink);width:40px;text-align:right;flex-shrink:0;font-variant-numeric:tabular-nums}

  /* ── Mobile ranked report (ported from soroby-redesign/assignees.html) ── */
  .sbr .top1{position:relative;background:var(--brand-grad);border-radius:var(--r);padding:17px 16px 16px;
    margin-bottom:16px;box-shadow:var(--sh-3),var(--sh-brand);overflow:hidden;color:#fff}
  .sbr .top1::after{content:"";position:absolute;right:-40px;top:-50px;width:170px;height:170px;border-radius:50%;
    background:rgba(255,255,255,.10)}
  .sbr .top1 .head{display:flex;align-items:center;gap:13px;position:relative;z-index:1}
  .sbr .top1 .av{position:relative;width:54px;height:54px;border-radius:16px;background:rgba(255,255,255,.18);
    border:1px solid rgba(255,255,255,.30);color:#fff;font-size:19px;font-weight:800;
    display:flex;align-items:center;justify-content:center;flex-shrink:0}
  /* the crown sits outside the avatar box, so it hangs off a wrapper — the
     avatar itself clips its own overflow to keep a photo inside the rounding */
  .sbr .top1 .avwrap{position:relative;flex-shrink:0;display:flex}
  .sbr .top1 .crown{position:absolute;top:-7px;left:-7px;width:24px;height:24px;border-radius:50%;background:#fff;
    color:var(--brand-ink);display:flex;align-items:center;justify-content:center;box-shadow:var(--sh-1)}
  .sbr .top1 .crown .ic{width:13px;height:13px}
  .sbr .top1 .who{min-width:0;flex:1}
  .sbr .top1 .nm{font-size:17px;font-weight:800;letter-spacing:-.4px;display:flex;align-items:center;gap:8px;flex-wrap:wrap}
  .sbr .top1 .rl{font-size:12.5px;font-weight:600;color:rgba(255,255,255,.82);margin-top:3px}
  .sbr .top1 .rank{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.5px;
    background:rgba(255,255,255,.18);border:1px solid rgba(255,255,255,.28);border-radius:999px;padding:5px 11px}
  .sbr .top1 .stats{display:flex;gap:10px;margin-top:15px;position:relative;z-index:1}
  .sbr .top1 .st{flex:1;min-width:0;background:rgba(255,255,255,.13);border:1px solid rgba(255,255,255,.16);
    border-radius:var(--r-sm);padding:9px 11px}
  .sbr .top1 .st .sl{font-size:10.5px;font-weight:700;color:rgba(255,255,255,.78);text-transform:uppercase;letter-spacing:.4px}
  .sbr .top1 .st .sv{font-size:15px;font-weight:800;letter-spacing:-.4px;margin-top:3px}

  .sbr .emp{position:relative;display:flex;gap:13px;background:var(--card);border:1px solid var(--line);
    border-radius:var(--r);padding:13px 14px;margin-bottom:11px;box-shadow:var(--sh-2);cursor:pointer;transition:transform .14s ease,box-shadow .14s ease}
  .sbr .emp:active{transform:scale(.99)}
  .sbr .emp .rk{flex-shrink:0;width:20px;text-align:center;font-size:13px;font-weight:800;color:var(--faint);
    align-self:flex-start;padding-top:4px;letter-spacing:-.5px}
  .sbr .emp .av{width:46px;height:46px;border-radius:14px;flex-shrink:0;display:flex;align-items:center;
    justify-content:center;font-size:15px;font-weight:800;color:#fff;box-shadow:var(--sh-1)}
  .sbr .emp .av.c1{background:linear-gradient(160deg,#34D399,#0EA5E9)}
  .sbr .emp .av.c2{background:linear-gradient(160deg,#A78BFA,#6D28D9)}
  .sbr .emp .av.c3{background:linear-gradient(160deg,#FBBF24,#D97706)}
  .sbr .emp .av.c4{background:linear-gradient(160deg,#60A5FA,#1D4FD8)}
  .sbr .emp .av.c5{background:linear-gradient(160deg,#F472B6,#BE185D)}
  .sbr .emp .av.c6{background:linear-gradient(160deg,#2DD4BF,#0F766E)}
  .sbr .emp .body{flex:1;min-width:0}
  .sbr .emp .top{display:flex;align-items:center;gap:8px}
  .sbr .emp .nm{flex:1;min-width:0;font-size:15px;font-weight:800;color:var(--ink);letter-spacing:-.3px;white-space:nowrap;
    overflow:hidden;text-overflow:ellipsis}
  .sbr .emp .role{font-size:10.5px;font-weight:800;text-transform:uppercase;letter-spacing:.4px;
    padding:3px 8px;border-radius:7px;flex-shrink:0}
  .sbr .emp .role.driver{color:var(--delivery);background:var(--delivery-bg)}
  .sbr .emp .role.cleaner{color:var(--cleaning);background:var(--cleaning-bg)}
  .sbr .emp .rev{margin-top:5px;font-size:15px;font-weight:800;color:var(--ink);letter-spacing:-.3px}
  .sbr .emp .rev small{font-size:11px;font-weight:700;color:var(--faint);letter-spacing:0}
  .sbr .emp .barrow{display:flex;align-items:center;gap:9px;margin-top:9px}
  .sbr .emp .barrow .track{flex:1}
  .sbr .emp .barrow .pct{font-size:11px;font-weight:800;color:var(--muted);flex-shrink:0;width:34px;text-align:right}
  .sbr .emp .sub{display:flex;align-items:center;gap:7px;margin-top:9px;font-size:12px;color:var(--muted);font-weight:600}
  .sbr .emp .sub .ic{width:13px;height:13px;color:var(--faint)}
  .sbr .emp .sub b{color:var(--text);font-weight:800}

  .sbr .totl{display:flex;align-items:center;gap:13px;background:var(--ink);border-radius:var(--r);
    padding:15px 16px;margin:4px 0 6px;box-shadow:var(--sh-2)}
  .sbr .totl .ic{width:22px;height:22px;color:#fff;flex-shrink:0}
  .sbr .totl .tx{flex:1;min-width:0}
  .sbr .totl .tx .l{font-size:11.5px;font-weight:700;color:rgba(255,255,255,.66);text-transform:uppercase;letter-spacing:.4px}
  .sbr .totl .tx .v{font-size:18px;font-weight:800;color:#fff;letter-spacing:-.5px;margin-top:2px}
  .sbr .totl .side{text-align:right;flex-shrink:0}
  .sbr .totl .side .l{font-size:11px;font-weight:700;color:rgba(255,255,255,.66)}
  .sbr .totl .side .v{font-size:14px;font-weight:800;color:#fff;margin-top:2px}
`;

function JobAssignees() {
  const [reportData, setReportData] = useState([])
  const [filter, setFilter] = useState([])
  const navigate = useNavigate()
  const { t } = useTranslation();

  const { data, isFetching } = useQuery(
    ['jobs', 'assignees-report', ...filter],
    () => getJobAssigneesReport(...filter)
  )

  useEffect(() => {
    onQuerySuccess(data, (result) => {
      setReportData(result)
    })
  }, [data])

  return (
    <div className="sbr">
      <style>{pageStyles}</style>

      {/* Desktop header */}
      <div className="dhead sbr-d">
        <div>
          <div className="ttl">{t('reports.assigneesReport')}</div>
          <div className="sub">{t('reports.assigneesSubtitle')}</div>
        </div>
        <div className="act">
          <button className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={() => navigate('/reports/jobs-history')}>
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            {t('reports.export')}
          </button>
          <button className="btn-sbr btn-primary-sbr btn-sm-sbr">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            {t('reports.thisMonth')}
          </button>
        </div>
      </div>

      {/* Mobile header */}
      <div className="sbr-m" style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-.8px', color: 'var(--ink)' }}>{t('reports.assignees')}</div>
        <div style={{ fontSize: 13, color: 'var(--muted)', fontWeight: 500, marginTop: 2 }}>{t('reports.assigneesMobileSubtitle')}</div>
      </div>

      {/* Filter */}
      <div style={{ marginBottom: 14 }}>
        <JobAssigneesReportFilter onFilter={setFilter} />
      </div>

      {/* Loading skeleton */}
      {isFetching && !reportData.length && (
        <SkeletonRows rows={6} widths={['8%', '24%', '22%', '22%', '22%']} />
      )}

      {/* Empty state */}
      {!isFetching && !reportData.length && (
        <div className="sbr-empty">
          <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
          {t('reports.noAssigneeDataFound')}
        </div>
      )}

      {reportData.length > 0 && (() => {
        const maxM2 = Math.max(...reportData.map(x => (x.totalPickup?.m2 || 0) + (x.totalCleaned?.m2 || 0) + (x.totalDelivered?.m2 || 0)), 1)
        const leader = reportData[0]
        const leaderM2 = (leader.totalPickup?.m2 || 0) + (leader.totalCleaned?.m2 || 0) + (leader.totalDelivered?.m2 || 0)
        const teamM2 = reportData.reduce((s, x) => s + (x.totalPickup?.m2 || 0) + (x.totalCleaned?.m2 || 0) + (x.totalDelivered?.m2 || 0), 0)
        // piece/job counts arrive as raw sums with binary FP noise (e.g. 295.03000000000003) — trim to a clean number
        const fmtNum = (n) => Number((Number(n) || 0).toFixed(2)).toLocaleString()

        return (
          <>
            {/* Top performer card */}
            <div className="topperf sbr-d">
              <Avatar className="tp-av" size={64} name={leader.name} src={leader?.avatarUrl} />
              <div className="tp-mid">
                <span className="tp-tag">
                  <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6m12 5h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/></svg>
                  {t('reports.topPerformer')}
                </span>
                <div className="tp-name">{leader.name || t('reports.assigneeN', { id: leader.id })}</div>
                <div className="tp-role">{t('reports.m2HandledThisPeriod', { count: leaderM2.toLocaleString() })}</div>
              </div>
              <div className="tp-stats">
                <div className="s"><div className="v">{leaderM2.toLocaleString()}</div><div className="k">{t('reports.m2Handled')}</div></div>
                <div className="s"><div className="v">{fmtNum(leader.totalCleaned?.piece)}</div><div className="k">{t('reports.jobsCleaned')}</div></div>
              </div>
            </div>

            {/* .cols layout */}
            <div className="cols sbr-d">
              {/* Main column: leaderboard */}
              <div>
                <div className="rank-cap">
                  <span className="t">{t('reports.teamLeaderboard')}</span>
                  <span className="h">{t('reports.employeesWorkload', { count: reportData.length })}</span>
                  <span className="line"></span>
                </div>

                {reportData.map((d, i) => {
                  const m2 = (d.totalPickup?.m2 || 0) + (d.totalCleaned?.m2 || 0) + (d.totalDelivered?.m2 || 0)
                  const pct = Math.round((m2 / maxM2) * 100)
                  return (
                    <div key={d.id} className={`arow${i === 0 ? ' lead' : ''}`}
                      onClick={() => navigate(`/reports/jobs-history/?deliveryAssignedToId=${d.id}&cleaningAssignedToId=${d.id}&pickupAssignedToId=${d.id}`)}>
                      <div className="rk">{i + 1}</div>
                      <Avatar className="av" size={42} name={d.name} src={d?.avatarUrl} />
                      <div className="who">
                        <div className="nm">{d.name || t('reports.assigneeN', { id: d.id })}</div>
                        <div className="rl">{roleLabel(d.role || (d.totalPickup ? 'driver' : 'cleaner'))}</div>
                      </div>
                      <div className="stat">
                        <div className="v">{fmtNum((d.totalCleaned?.piece || 0) + (d.totalPickup?.piece || 0) + (d.totalDelivered?.piece || 0))}</div>
                        <div className="k">{t('reports.jobsLabel')}</div>
                      </div>
                      <div className="stat">
                        <div className="v">{m2.toLocaleString()} m²</div>
                        <div className="k">{t('reports.area')}</div>
                      </div>
                      <div className="wl">
                        <div className="wl-top">
                          <span className="wl-lab">{t('reports.workload')}</span>
                          <span className="wl-pct">{pct}%</span>
                        </div>
                        <div className="track"><i style={{ width: `${pct}%` }}></i></div>
                      </div>
                    </div>
                  )
                })}
              </div>

              {/* Right rail */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {/* Team totals */}
                <div className="card-sbr" style={{ margin: 0 }}>
                  <div className="ch">
                    <svg className="ci" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.9"/></svg>
                    <span className="t">{t('reports.teamThisPeriod')}</span>
                  </div>
                  {[
                    { label: t('reports.activeEmployees'), value: reportData.length },
                    { label: t('reports.totalAreaHandled'), value: `${teamM2.toLocaleString()} m²` },
                    { label: t('reports.jobsCleanedLabel'), value: fmtNum(reportData.reduce((s, x) => s + (x.totalCleaned?.piece || 0), 0)) },
                    { label: t('reports.jobsPickupLabel'), value: fmtNum(reportData.reduce((s, x) => s + (x.totalPickup?.piece || 0), 0)) },
                  ].map(({ label, value }) => (
                    <div key={label} className="row">
                      <div className="info"><div className="nm" style={{ fontWeight: 600, fontSize: 13, color: 'var(--muted)' }}>{label}</div></div>
                      <div className="rt"><div className="v num">{value}</div></div>
                    </div>
                  ))}
                </div>

                {/* Area share bars */}
                <div className="card-sbr" style={{ margin: 0 }}>
                  <div className="ch">
                    <svg className="ci" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M18 20V10M12 20V4M6 20v-6"/></svg>
                    <span className="t">{t('reports.areaShare')}</span>
                  </div>
                  {reportData.map(d => {
                    const m2 = (d.totalPickup?.m2 || 0) + (d.totalCleaned?.m2 || 0) + (d.totalDelivered?.m2 || 0)
                    const pct = teamM2 > 0 ? Math.round((m2 / teamM2) * 100) : 0
                    const shortName = d.name ? d.name.split(' ').map((n, i) => i === 0 ? n : n[0] + '.').join(' ') : `#${d.id}`
                    return (
                      <div key={d.id} className="barrow">
                        <span className="bn">{shortName}</span>
                        <div className="track" style={{ flex: 1 }}><i style={{ width: `${pct}%` }}></i></div>
                        <span className="bv">{pct}%</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>

            {/* Mobile: ranked report — top performer hero + emp rows + team totals */}
            <div className="sbr-m">
              {/* #1 top performer */}
              <div className="top1">
                <div className="head">
                  <div className="avwrap">
                    <Avatar className="av" size={54} name={leader.name} src={leader?.avatarUrl} />
                    <span className="crown"><svg className="ic" viewBox="0 0 24 24" fill="currentColor"><path d="M2 7l5 5 5-7 5 7 5-5-2 12H4z"/></svg></span>
                  </div>
                  <div className="who">
                    <div className="nm">{leader.name || t('reports.assigneeN', { id: leader.id })}<span className="rank">{t('reports.topPerformer')}</span></div>
                    <div className="rl">{roleLabel(leader.role || (leader.totalPickup ? 'driver' : 'cleaner'))}</div>
                  </div>
                </div>
                <div className="stats">
                  <div className="st"><div className="sl">{t('reports.area')}</div><div className="sv num">{leaderM2.toLocaleString()} m²</div></div>
                  <div className="st"><div className="sl">{t('reports.jobsLabel')}</div><div className="sv num">{fmtNum((leader.totalCleaned?.piece || 0) + (leader.totalPickup?.piece || 0) + (leader.totalDelivered?.piece || 0))}</div></div>
                </div>
              </div>

              {/* ranked rows (rank 2+) */}
              {reportData.slice(1).map((d, idx) => {
                const i = idx + 1
                const m2 = (d.totalPickup?.m2 || 0) + (d.totalCleaned?.m2 || 0) + (d.totalDelivered?.m2 || 0)
                const jobs = (d.totalCleaned?.piece || 0) + (d.totalPickup?.piece || 0) + (d.totalDelivered?.piece || 0)
                const pct = Math.round((m2 / maxM2) * 100)
                const roleText = roleLabel(d.role || (d.totalPickup ? 'driver' : 'cleaner'))
                const roleClass = String(d.role || (d.totalPickup ? 'driver' : 'cleaner')).toLowerCase().includes('driver') ? 'driver' : 'cleaner'
                return (
                  <div key={d.id} className="emp"
                    onClick={() => navigate(`/reports/jobs-history/?deliveryAssignedToId=${d.id}&cleaningAssignedToId=${d.id}&pickupAssignedToId=${d.id}`)}>
                    <div className="rk num">{i + 1}</div>
                    <Avatar className={`av c${(i % 6) + 1}`} size={46} name={d.name} src={d?.avatarUrl} />
                    <div className="body">
                      <div className="top">
                        <span className="nm">{d.name || t('reports.assigneeN', { id: d.id })}</span>
                        <span className={`role ${roleClass}`}>{roleText}</span>
                      </div>
                      <div className="rev num">{m2.toLocaleString()} m² <small>{t('reports.handled')}</small></div>
                      <div className="barrow">
                        <div className="track"><i style={{ width: `${pct}%` }}></i></div>
                        <span className="pct num">{pct}%</span>
                      </div>
                      <div className="sub">
                        <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
                        <b className="num">{fmtNum(jobs)}</b> {t('reports.jobsLowercase')}
                      </div>
                    </div>
                  </div>
                )
              })}

              {/* team totals */}
              <div className="totl">
                <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.9"/></svg>
                <div className="tx">
                  <div className="l">{t('reports.teamAreaHandled')}</div>
                  <div className="v num">{teamM2.toLocaleString()} m²</div>
                </div>
                <div className="side">
                  <div className="l">{t('reports.totalJobs')}</div>
                  <div className="v num">{fmtNum(reportData.reduce((s, x) => s + (x.totalCleaned?.piece || 0) + (x.totalPickup?.piece || 0) + (x.totalDelivered?.piece || 0), 0))}</div>
                </div>
              </div>
            </div>

            {isFetching && <OverlayLoader />}
          </>
        )
      })()}
    </div>
  )
}

export default JobAssignees
